module.exports = __webpack_public_path__ + "img/zombie.bc06fdd2.jpg";